var radios = document.querySelectorAll('.product_card_swtches_wrp .product-form__input--swatch input[type=radio]');
if (radios) {
    radios.forEach(function (radio) {
        radio.addEventListener('change', function (event) {
            console.log("custom swatches");
            $target = event.target;
            var value = event.target.value;
            var optionWrp = $target.closest('.product_card_swtches_wrp');
            optionWrp.querySelector('fieldset .form__label span').innerHTML = value;
            if (optionWrp) {
                var optionSelector = optionWrp.nextElementSibling;
                if (optionSelector) {
                    optionSelector.querySelectorAll('option').forEach(function (option, index) {
                        var $option = $(option);
                        var opt_val = $option.val();
                        if (opt_val == $target.dataset.varid) {
                            var wrp_main = $target.closest(`.quick_view_card_wrpper`);
                            // image change
                            var imgElement = wrp_main.querySelector('.card__media img.first_image_wrp');
                            imgElement.src = $option.attr('data-imgsrc');
                            imgElement.srcset = $option.attr('data-imgsrc');
                            // price change
                            var priceElemSale = wrp_main.querySelector('.info_wrp .price .price__sale span.price-item');
                            var priceElemReg = wrp_main.querySelector('.info_wrp .price .price__regular span.price-item');
                            priceElemSale.innerHTML = $option.attr('data-price');
                            priceElemReg.innerHTML = $option.attr('data-price');
                            // cprice
                            var Cprice = $option.attr('data-cprice');
                            var cPriceElemSale = wrp_main.querySelector('.info_wrp .price .price__sale .cprice_wrp');
                            var cPriceElemReg = wrp_main.querySelector('.info_wrp .price .price__regular .cprice_wrp');
                            if (Cprice) {
                                cPriceElemSale.innerHTML = Cprice;
                                if (cPriceElemReg) {
                                    cPriceElemReg.innerHTML = Cprice;
                                }
                            } else {
                                cPriceElemSale.innerHTML = '';
                                if (cPriceElemReg) {
                                    cPriceElemReg.innerHTML = '';
                                }
                            }
                        }
                    });
                }
            }
        });
    });
}
// custom code for product card swatches

// product grid/list
function listgridJavascript() {
    Array.from(document.querySelectorAll(".btnsgrid")).forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            Array.from(document.querySelectorAll(".btnsgrid")).forEach(e => e.classList.remove('active'));
            this.classList.add('active');
            if(this.classList.contains('gridvfour')){
                document.getElementById('product-grid').classList.add('grid--4-col-desktop');
                document.getElementById('product-grid').classList.remove('grid--5-col-desktop');
            }else if(this.classList.contains('gridvfive')){
                document.getElementById('product-grid').classList.add('grid--5-col-desktop');
                document.getElementById('product-grid').classList.remove('grid--4-col-desktop');
            }
        });
    });
    };
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

document.addEventListener('DOMContentLoaded', function () {
  $(".filter_icon").click(function(){
      $(".facets-vertical .facets-wrapper").toggleClass("hidden");
      $(".facets-vertical .facets-wrapper").toggleClass("drawer--visible");
  });
});



// pdp related products slider
 document.addEventListener('DOMContentLoaded', function () {

    if (
      typeof window.jQuery === 'undefined' ||
      typeof jQuery.fn === 'undefined' ||
      typeof jQuery.fn.slick === 'undefined'
    ) {
      return;
    }

    const $relatedSlider = $('.related_prc_slider');

    if (!$relatedSlider.length) return;

    if (!$relatedSlider.hasClass('slick-initialized')) {
      $relatedSlider.slick({
        centerMode: false,
        centerPadding: '20px',
        slidesToShow: 1,
        infinite: true,
        arrows: true,
        responsive: false,
        adaptiveHeight: true
      });
    }

});

// $('.related_prc_slider').slick({
//     centerMode: false,
//     centerPadding: '20px',
//     slidesToShow: 1,
//     infinite: true,
//     arrows: true,
//     responsive: false,
//     adaptiveHeight: true,
// });

// Blog left sidebar Drawer Javascript
class ArticleToggle extends HTMLElement {
    constructor() {  
      super();
      this.sidebar = this.querySelector('.sidebar');
      this.toggleButton = this.querySelector('.toggle-button');
      this.closeBtn = this.querySelector('.sidebar-close');
      this.toggleButton.addEventListener('click', this.toggleSidebar.bind(this)); 
      this.closeBtn.addEventListener('click', this.closeSidebar.bind(this));
    }
    toggleSidebar() {
        console.log("toggle");
      this.sidebar.classList.add('active');
      document.body.classList.add("overflow-hidden");
    }
    closeSidebar() {
      this.sidebar.classList.remove('active');
      document.body.classList.remove("overflow-hidden");
    }
  }
  customElements.define('article-toggle', ArticleToggle); 
  

// bundleset step js 

// active = li that is open
// complete = li that has been opened and had next clicked
// current = last li that was open, not completed
jQuery(document).ready(function($) {
    $('.bundle-product-btn').attr('disabled','disabled');



	$('.steps-widget').on('click', '.btn-next', function(e) {
			e.preventDefault();
			//save reference to parent li for faster performance
			var li = $(this).closest('li');
    
			if ($(li).next('li').length === 0) {
					// alert('submited');
                    $('.bundle-product-btn').attr('disabled',false);
                    $(li).addClass('complete').removeClass('active');
					return false;
			}
			
			$(li).prevAll().removeClass('current');
			// move to next step on next button click; add complete class to li
			$(li).addClass('complete').removeClass('active').next('li').addClass('active current');
			
	}).on('click', 'li.complete .label, li.current .label', function(e) {
			
			e.preventDefault();
			var li = $(this).closest('li');
			$(li).addClass('active').siblings('li.active').removeClass('active')
	})
});


// bundleset js
var theme_custom = theme_custom || {};

// add bundleset
$(document).on("click", ".bundle-product-btn", function () {
  $(this).addClass("disabled");
  var list_node = $(this).closest('.product-bundles-wraper').find('[data-custom-bundle]');
  var mainProductObjj = $(this).closest('.product-bundles-wraper').attr(`data-main-prod-obj`);
  theme_custom.bundleProAddToCartObj(list_node, mainProductObjj);
});

// remove bundleset
$(document).on("click", ".remove_bundle_product", function () {
  var target = $(this).closest(".bundle-product").attr("data-item-time-id");
  theme_custom.removeBundle = $(this).closest(".bundle-product").attr("data-item-time-id");
  var data = '';
  $(`.m-cart-drawer-item[data-item-time-id="${target}"]`).each(function (index) {
    var isLastElement = $(`.m-cart-drawer-item[data-item-time-id="${target}"]`).length - 1;
    var itemKey = $(this).attr("data-item-key");
    // console.log(isLastElement);
    // console.log(itemKey);
    if (index == isLastElement) {
      data += `updates[${itemKey}]=0`;
    } else {
      data += `updates[${itemKey}]=0&`;
    }
  })
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    success: function (response) {
      $(`.bundle-product[data-item-time-id="${theme_custom.removeBundle}"`).remove();
      refreshCartDrawer(response);
      
      
    }
  });
});

theme_custom.bundleProAddToCartObj = function (list_node, mainProductObjj) {
  const addToCartObj = {
    items: []
  };

  // let bundleProEle = document.querySelectorAll('[data-custom-bundle]');
  let bundleProEle = list_node;
  console.log(bundleProEle);
  if (!bundleProEle.length) return;
  let customTimeId = Date.now();
  let mainProductObj = JSON.parse(mainProductObjj);
  let mainProductTitle = mainProductObj.title;
  let mainProductTit = mainProductObj.mainProductTil;
  let mainProductImgUrl = mainProductObj.imgSrc;
  let mainProductPrice = mainProductObj.price;
  let mainProductPriceNoMoney = mainProductObj.priceWithoutMoney;
  let mainProductComparePriceNoMoney = mainProductObj.ComparePriceWithoutMoney;
  let mainProductCmpPrice = mainProductObj.compareAtPrice;
  let mainProductUrl = mainProductObj.url;
  console.log(mainProductComparePriceNoMoney);
  for (let i = 0; i < bundleProEle.length; i++) {
    console.log("Target variant", bundleProEle[i])
    let slectedBdId = parseInt($(bundleProEle[i]).find(`.product-data-variant-selector`).val());
    let slectedBdVarinatTitle = $(bundleProEle[i]).find(`.product-data-variant-selector option:selected`).attr("data-variant-title");
    let slectedBdVarinatImg = $(bundleProEle[i]).find(`.product-data-variant-selector option:selected`).attr("data-variant-image");
    let slectedBdProductTitle = bundleProEle[i].dataset.product;
    let combineTitle = `${slectedBdProductTitle} : ${slectedBdVarinatTitle}`;
    if (slectedBdVarinatTitle == null) {
      combineTitle = slectedBdProductTitle;
    }
    if (i === 0) {
      addToCartObj['items'].push({
        "id": slectedBdId,
        "quantity": 1,
        "properties": {
          "_masterProduct": "master-product",
          "_timeId": `${customTimeId}`,
          "_selectedTitle": `${combineTitle}`,
          "_selectedImg": `${slectedBdVarinatImg}`,
          "_mainProImgUrl": `${mainProductImgUrl}`,
          "_mainProductTitle": `${mainProductTitle}`,
          "_mainProductTit": `${mainProductTit}`,
          "_mainProductPrice": `${mainProductPrice}`,
          "_mainProductUrl": `${mainProductUrl}`,
          "_mainProductCompareAtPrice": `${mainProductCmpPrice}`,
          "_mainProductPriceNoMoney": `${mainProductPriceNoMoney}`,
          "_mainProductComparePriceNoMoney": `${mainProductComparePriceNoMoney}`
        }
      });
    } else {
      addToCartObj['items'].push({
        "id": slectedBdId,
        "quantity": 1,
        "properties": {
          "_masterProduct": "child-product",
          "_timeId": `${customTimeId}`,
          "_selectedTitle": `${combineTitle}`,
          "_selectedImg": `${slectedBdVarinatImg}`,
          "_mainProImgUrl": `${mainProductImgUrl}`,
          "_mainProductTitle": `${mainProductTitle}`,
          "_mainProductTit": `${mainProductTit}`,
          "_mainProductPrice": `${mainProductPrice}`,
          "_mainProductUrl": `${mainProductUrl}`,
          "_mainProductCompareAtPrice": `${mainProductCmpPrice}`,
          "_mainProductPriceNoMoney": `${mainProductPriceNoMoney}`,
          "_mainProductComparePriceNoMoney": `${mainProductComparePriceNoMoney}`
        }
      });
    }
  }
  console.log("addToCartObj", addToCartObj);
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: addToCartObj,
    dataType: 'json',
    success: function (response) {
      refreshCartDrawer(response);
      $(`.bundle-product-btn`).removeClass("disabled");
    }

  });
}

// $(document).on("click", ".bundleset-quick-add-modal__content-info variant-selects input[type=radio]", function (e) {
// });
$(document).on("change paste keyup", `bundleset-quick-add-modal .product__info-wrapper product-form form input[name=id]`, function (e) {
  var quickViewId = $(this).closest('bundleset-quick-add-modal').attr('id');
  const optionElement = $(`.btn_quick_vew select.product-data-variant-selector[name=${quickViewId}] option:selected`);
  if (optionElement.is(":disabled")) {
    $(this).closest('.product__info-wrapper').find('.action .my_step_btn').attr('disabled',true);
  } else {
    $(this).closest('.product__info-wrapper').find('.action .my_step_btn').attr('disabled',false);
  }
});

$(document).on("click", ".my_step_btn", function (e) {
    var quickViewId = $(this).closest('bundleset-quick-add-modal').attr('id');
    $(this).closest('bundleset-quick-add-modal').find(`button[aria-label="Close"]`).trigger('click');
    $(`.steps-list .item_wrp .action[data-btnnext=${quickViewId}]`).find('button.btn-next').trigger('click');


    var selectedVarId = $(this).closest('.product__info-wrapper').find(`product-form form input[name="id"]`).val();
    $(`.btn_quick_vew select.product-data-variant-selector[name=${quickViewId}]`).val(selectedVarId).trigger('change');
    
    var variantImg = $(`.btn_quick_vew select.product-data-variant-selector[name=${quickViewId}]`).find(':selected').attr("data-variant-image");
    if (variantImg) {
      $(`.steps-list .item_wrp[data-qid=${quickViewId}]`).find(`.product-img img`).attr("src", variantImg);
    }
    
    var getVariantTit = $(`.btn_quick_vew select.product-data-variant-selector[name=${quickViewId}]`).find(':selected').attr('data-variant-title');
    $(`.steps-list .item_wrp[data-qid=${quickViewId}]`).find('.sel_variant_txt').html(getVariantTit);
  
});




function refreshCartDrawer() {
    // Find the cart-drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {       
      // Make the form tag's class 'cart__contents' display as block
      const cartContentsForm = document.querySelector('.cart__contents');
      if (cartContentsForm) {
        cartContentsForm.style.display = 'block';
      }
      // Check if cart-drawer-items exists
      let cartDrawerItems = document.querySelector('cart-drawer-items');
      // If cart-drawer-items doesn't exist, create it
      if (!cartDrawerItems) {
        cartDrawerItems = document.createElement('cart-drawer-items');
        // Find the drawer__header element
        const drawerHeader = document.querySelector('.drawer__header');
        if (drawerHeader) {
          drawerHeader.insertAdjacentElement('afterend', cartDrawerItems);
        }
      }
      document.querySelector('cart-drawer-items').onCartUpdate();
      setTimeout(function(){
        if ($(`.cart-item`).length > 0) {
          $(`cart-drawer`).removeClass('is-empty');
        } else {
          $(`cart-drawer`).addClass('is-empty');
        }
        fetch('/cart.js')
        .then((resp) => resp.json())
        .then((data) => {
          $(".cart-count-bubble").text(data.item_count);
        });
      },600);
      if (cartDrawer) {
        cartDrawer.open();
      }
      
  
    }
  }


// megamenu open on hover
// megamenu open on hover
let items = document.querySelectorAll(".mega-menu");
let header = document.querySelector("header");
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");

  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open");
    }

    currentItemIndex = itemIndex;
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", (event) => {
    let close = true;

    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute("open");
    }, 500);

    content.addEventListener("mouseover", () => {
      close = false;
    });

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
    });
  });

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});
// megamenu open on hover
// megamenu open on hover

// footer agree checkbox
// footer agree checkbox
function agree() {
  if ($('#terms').prop('checked')){
    $('.newsletter-form__button').prop('disabled', false);
  }else{
    $('.newsletter-form__button').prop('disabled', true);
  }
}
// footer agree checkbox
// footer agree checkbox